import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { completeness } from '../lib/completeness';
import OpenRequests from './OpenRequests';
import ConnectionRequestsCard from './ConnectionRequestsCard';
import Invites from './Invites';
import Icon from './Icon';
import PromoteCard from './PromoteCard';
import OutcomeAsk from './OutcomeAsk';
import { FindInput } from './FindBar';

/* The right column: tools, not content. Search, connection requests you can
   answer in place, your open requests, Promote, inviting someone and at most
   one next step. (What the feed shows — All, My posts, Saved… — is the filter
   on Home's "Discover relevant posts" line.)
   Matcher internals (your interests, news sources) only show on News, where
   they explain the ranking you're looking at. */

export default function RightRail({
  view, onGo, refresh, onOpenPost, notify, onHomeView, query, onQuery, onRequestsChanged,
}) {
  const [interests, setInterests] = useState([]);
  const [sources, setSources] = useState([]);
  const [inviting, setInviting] = useState(false);
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    api.me().then(setProfile).catch(() => {});
    if (view === 'news') {
      api.interests().then(setInterests).catch(() => {});
      api.newsSources().then(setSources).catch(() => {});
    }
  }, [view, refresh]);

  const done = completeness(profile, profile?.intent);

  return (
    <aside className="app-rail">
      <FindInput value={query} onChange={(q) => { onQuery(q); if (q && view !== 'home') onGo('home'); }} />

      <OutcomeAsk notify={notify} />
      <ConnectionRequestsCard refresh={`${view}:${refresh}`} onGo={onGo} notify={notify} />
      <OpenRequests refresh={`${view}:${refresh}`} onOpen={onOpenPost} notify={notify} onChanged={onRequestsChanged}
        onViewAll={() => { onQuery(''); onHomeView('requests'); onGo('home'); }} />

      {/* The one ad slot: high enough to be seen without scrolling, clearly
          labelled, never inside Copilot, introductions or messages. */}
      <PromoteCard notify={notify} onGo={onGo} />

      <button type="button" className="invite-cta" onClick={() => setInviting(true)}>
        <span className="invite-text"><b>Invite someone</b><span>Bring builders to B/N</span></span>
        <span className="invite-icon" aria-hidden="true"><Icon name="share" size={22} /></span>
      </button>

      {/* One next step, never two: an introduction waiting on you beats
          finishing your profile. */}
      {profile && done.percent < 100 ? (
        <div className="card pad next-step">
          <h3 className="card-title">Your next step</h3>
          <p className="muted-sm">Your profile is {done.percent}% done — it's what your introductions are made from.
            {done.next && <> Next: <b>{done.next.label}</b>.</>}</p>
          <button className="btn ghost sm" onClick={() => onGo('profile', { focus: done.next?.key })}>Continue</button>
        </div>
      ) : null}

      {view === 'news' && (
        <div className="card pad">
          <h3 className="card-title">Your interests</h3>
          <p className="muted-sm">What the system thinks you care about, and why news ranks the way it does.</p>
          <ul className="interests">
            {interests.length === 0 && <li className="muted-sm">Nothing learned yet — react to a few things and this fills in.</li>}
            {interests.slice(0, 8).map((i) => (
              <li key={i.category}><span>{i.category}</span><b>{i.weight}</b></li>
            ))}
          </ul>
        </div>
      )}
      {view === 'news' && sources.length > 0 && (
        <div className="card pad">
          <h3 className="card-title">Sources</h3>
          <p className="muted-sm">{sources.length} across Web3 and AI, pulled every 30 minutes. Headlines and link-outs only.</p>
          <p className="wire-list">{sources.map((s) => s.label).join(' · ')}</p>
        </div>
      )}

      {inviting && (
        <div className="modal-back" role="presentation" onClick={() => setInviting(false)}>
          <div className="modal wide card pad" role="dialog" aria-modal="true" aria-label="Invite someone" onClick={(e) => e.stopPropagation()}>
            <div className="modal-top">
              <h2>Invite someone to B/N</h2>
              <button className="linklike" aria-label="Close" onClick={() => setInviting(false)}>×</button>
            </div>
            <p className="muted-sm">Invite builders who aren't here yet. They join through your invite and you're connected automatically.</p>
            <Invites notify={notify} />
          </div>
        </div>
      )}
    </aside>
  );
}
